import { deleteDeviceMeta, getFunctionAppVersion, putFunctionAppVersion, writeDeviceMeta } from '../db/deviceStore';
import * as hazardGateway from '../db/hazardGateway';
import { fetchFunctionAppVersionPayload } from './functionVersionClient';

const VERSION_KEY = 'functionAppVersion';
const PENDING_CACHE_RESET = 'pendingCacheReset';

async function fetchBackendVersion(): Promise<{
  lastModified: string;
  timestamp: number;
} | null> {
  const json = await fetchFunctionAppVersionPayload();
  if (!json) {
    return null;
  }
  return {
    lastModified: String(json.lastModified ?? ''),
    timestamp: Number(json.timestamp ?? 0),
  };
}

export async function ensureLatestBackendVersion(): Promise<boolean> {
  const versionInfo = await fetchBackendVersion();
  if (!versionInfo) {
    return false;
  }

  const existing = await getFunctionAppVersion();
  const incomingTs = Number(versionInfo.timestamp || 0);
  const existingTs = Number(existing?.timestamp || 0);
  const isNewer = incomingTs > existingTs;

  if (isNewer) {
    await writeDeviceMeta(PENDING_CACHE_RESET, '1');
    if (hazardGateway.hasOpenStore()) {
      await hazardGateway.clearSynced();
      await deleteDeviceMeta(PENDING_CACHE_RESET);
    }
    await putFunctionAppVersion({
      key: VERSION_KEY,
      lastModified: versionInfo.lastModified,
      fileSize: existing?.fileSize || 0,
      timestamp: incomingTs,
      lastChecked: new Date().toISOString(),
    });
  } else {
    await putFunctionAppVersion({
      key: VERSION_KEY,
      lastModified: versionInfo.lastModified,
      fileSize: existing?.fileSize || 0,
      timestamp: existingTs,
      lastChecked: new Date().toISOString(),
    });
  }

  return isNewer;
}

export async function maybeReloadIfUpdated(): Promise<void> {
  const updated = await ensureLatestBackendVersion();
  if (updated) {
    window.location.reload();
  }
}
